import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { SellComponent } from '../sell/sell.component';
import { BOSell } from '../../models/BOSell.model';
import { SellService } from '../../services/sell.service';
import { forkJoin, Subscription } from 'rxjs';
import { BOFilter } from '../../models/BOFilter';
import { PayTypeService } from '../../services/payType.service';
import { BOPayType } from '../../models/BOPayType.model';
import { BOInvoiceType } from '../../models/BOInvoiceType.model';
import { InvoiceTypeService } from '../../services/invoiceType.service';
import { BOClinicHistory } from '../../models/BOClinicHistory.model';
import { MatSelectChange } from '@angular/material/select';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { PersonService } from '../../services/person.service';
import { BOPerson } from '../../models/BOPerson.model';
import { Utilities } from '../../common/utilities';

@Component({
  selector: 'invoicesTask',
  templateUrl: './invoices-task.component.html',
  styleUrls: ['./invoices-task.component.css']
})
export class InvoicesTaskComponent implements OnInit, OnDestroy
{
  @ViewChild('sellModal') public sellModal: SellComponent;
    @ViewChild('invoicesTask', { static: true }) modal: ModalDirective;

  busy: Subscription | undefined;
  sellFilter:string="";

  sellList:BOSell[]=[];
    sellListShort:BOSell[]=[];

  invoiceTypeList:BOInvoiceType[]=[];
  selectedArea=0;
  person:BOPerson=new BOPerson();
  namePerson:string=" ";

  clinicHistoryList: BOClinicHistory[];
  clinicHistoryListShort: BOClinicHistory[];

  payTypeList:BOPayType[]=[];



  constructor(private _sellService: SellService,
              private _invoiceTypeService: InvoiceTypeService,
              private _payTypeService:PayTypeService,
              private _personService: PersonService,
              private _changeDetectorRef : ChangeDetectorRef,
              ) { }

  ngOnDestroy(): void {
  this.busy.unsubscribe();

  }

  ngOnInit(): void
  {
    const filterInput:BOFilter={
      filter:this.sellFilter
    }

    this.busy = forkJoin({
      resultSells:this._sellService.getSells(filterInput),
      resultInvoiceType:this._invoiceTypeService.getAll(),
      resultPayType: this._payTypeService.getAll(),
    })
    .subscribe(({resultSells, resultInvoiceType, resultPayType})=>{
      this.sellList=resultSells;
      this.payTypeList=resultPayType;
      this.invoiceTypeList=resultInvoiceType;


      this.sellList.forEach(x=>{
        x.documentNumberInt=parseInt(x.documentNumber);
      })

      this.sellList.sort((a, b) => (b.documentNumberInt ?? 0) - (a.documentNumberInt ?? 0));

      this.sellListShort=this.sellList;
      //this.sellList.sort((a,b)=>{return new Date(b.dateSell).getTime() -new Date(a.dateSell).getTime()});

      this.sellList.forEach(x=>{
        x.payTypeSellDetails.forEach(pt=>{
          pt.payTypeName=this.payTypeList.find(z=>z.id==pt.payTypeId)?.name;
        })
      })

      this.sellList.forEach(x=>{
        x.invoiceTypeName=this.invoiceTypeList.find(z=>z.id==x.invoiceTypeId)?.name;
      })
    })

  }

  ngOnInit2(userId:string): void
  {
    //userId es número de documento de identidad

    const filterInput:BOFilter={
      filter:this.sellFilter
    }

    this.busy = forkJoin({
      resultInvoiceType:this._invoiceTypeService.getAll(),
      resultPayType: this._payTypeService.getAll(),
      resultPerson: this._personService.getPersonByDocumentIdString(userId)

    })
    .subscribe(({ resultInvoiceType, resultPayType, resultPerson})=>{
      this.payTypeList=resultPayType;
      this.invoiceTypeList=resultInvoiceType;
      this.person=resultPerson;
      this.getAllSellsByUserIdString(userId);
      this.namePerson=Utilities.getNameFromPerson(this.person);
    })
    this.modal.config = { backdrop: "static", keyboard: false };
    this.modal.show();

  }

  ngOnInit3(clinicHistoryId:number, userId:string): void
  {
    //userId es número de documento de identidad
    const filterInput:BOFilter={
      filter:this.sellFilter
    }

    this.busy = forkJoin({
      resultInvoiceType:this._invoiceTypeService.getAll(),
      resultPayType: this._payTypeService.getAll(),
      resultSell: this._sellService.getAllSellsByClinicHistoryId(clinicHistoryId),
      resultPerson: this._personService.getPersonByDocumentIdString(userId)

    })
    .subscribe(({ resultInvoiceType, resultPayType, resultPerson, resultSell})=>{
      this.payTypeList=resultPayType;
      this.invoiceTypeList=resultInvoiceType;
      this.sellList=resultSell;
      this.person=resultPerson;

      this.sellList.forEach(x=>{
        x.documentNumberInt=parseInt(x.documentNumber);
        x.invoiceTypeName=this.invoiceTypeList.find(z=>z.id==x.invoiceTypeId)?.name;
        x.payTypeSellDetails.forEach(pt=>{
          pt.payTypeName=this.payTypeList.find(z=>z.id==pt.payTypeId)?.name;
        })
      })

      this.sellList.sort((a, b) => (b.documentNumberInt ?? 0) - (a.documentNumberInt ?? 0));
      this.sellListShort=this.sellList;

      this.namePerson=Utilities.getNameFromPerson(this.person);
    })
    this.modal.config = { backdrop: "static", keyboard: false };
    this.modal.show();

  }






  getAllSells():void
  {
    this.sellList=[];
      this.sellListShort=[];

      const filterInput: BOFilter = {
          filter: this.sellFilter.toUpperCase().trim()
      };

      this.busy = this._sellService.getSells(filterInput)
      .subscribe(data=>{this.sellList = data;
          this.sellList.forEach(x=>{
            x.documentNumberInt=parseInt(x.documentNumber);
            x.invoiceTypeName=this.invoiceTypeList.find(z=>z.id==x.invoiceTypeId)?.name;
          })

          this.sellList.sort((a, b) => (b.documentNumberInt ?? 0) - (a.documentNumberInt ?? 0));
          this.sellListShort=this.sellList;

      });
  }

  getAllSellsByUserIdString(userId:string):void
  {
    this.sellList=[];
      this.sellListShort=[];

      const filterInput: BOFilter = {
          filter: this.sellFilter.toUpperCase().trim()
      };

      this.busy = this._sellService.getAllSellsByUserIdString(userId)
      .subscribe(data=>{this.sellList = data;
          this.sellList.forEach(x=>{
            x.documentNumberInt=parseInt(x.documentNumber);
            x.invoiceTypeName=this.invoiceTypeList.find(z=>z.id==x.invoiceTypeId)?.name;
            x.payTypeSellDetails.forEach(pt=>{
              pt.payTypeName=this.payTypeList.find(z=>z.id==pt.payTypeId)?.name;
            })
          })

          this.sellList.sort((a, b) => (b.documentNumberInt ?? 0) - (a.documentNumberInt ?? 0));
          this.sellListShort=this.sellList;

      });

  }

  openUrl(url: string): void {
    if (url) {
      window.open(url, '_blank');
    } else {
      console.error('URL inválida o no especificada.');
    }
  }

  onAreaSelectionChange(event: MatSelectChange): void
  {
    const selectedValue = event.value;
    this.selectedArea=selectedValue;

    this.sellListShort=[];

    if(this.selectedArea==3)
    {
     this.sellListShort=[...this.sellList];
    }
    else
    {
    let sellListFiltered=this.sellList.filter(x=>x.areaId==this.selectedArea);
    this.sellListShort=[...sellListFiltered];
    this._changeDetectorRef.detectChanges();
    }
  }

  close(): void {
    this.modal.hide();
  }

}
